/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import constants from '../../utils/constants';

const GetStartedToday = () => {
  const { KabbageSimple } = constants;

  return (
    <section className="med-hi dark-blue get-started-today">
      <div className="image-container">
        <div className="container">
          <h2 className="h1-style">
            Get started now.
            <br />
            Have working capital today.
          </h2>
          <div className="two-column">
            <div className="column">
              <h5>Minimum requirements</h5>
              <div className="text">
                To qualify for a small business loan, your business needs to be
                at least a year old. You should have revenues of $50,000
                annually or $4,200 per month over the last three months.
                <sup>4</sup>
              </div>
            </div>
            <div className="column">
              <h5>
                Get the <KabbageSimple /> app
              </h5>
              <div className="text mobile-parent">
                Apply, use your funds and manage your account right from your
                phone with the <KabbageSimple /> app. It&#39;s the best funding
                you can get with two thumbs.
              </div>
              <div className="apps">
                <a
                  href="https://control.kochava.com/v1/cpi/click?campaign_id=kokabbage-ios571109f58fdb7b3c6f00ecb107&network_id=8494&site_id=1&device_id=device_id"
                  className="pill-button apple"
                />
                <a
                  href="https://control.kochava.com/v1/cpi/click?campaign_id=kokabbage-android57110b6b724acdf98f0e098724&network_id=8494&site_id=1&device_id=device_id"
                  className="pill-button google"
                />
              </div>
            </div>
          </div>
          <h2 className="h1-style state-funding">
            We&#39;ve provided over <span>$9 Billion</span> in funding to more
            than <span>200,000 businesses.</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default GetStartedToday;
